module.exports = require('../dist/utils/meta-data');
